<template>
    <div class="leading-normal tracking-normal" id="main-body">
        <div class="flex flex-wrap bg-gray-50 overflow-x-hidden">
            <Sidebar class="w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/5 fixed md:top-0 md:left-0" :class="sideBarOpen ? '' : 'hidden'" />
            <div class="w-full ml-auto lg:w-3/4 xl:w-4/5 pl-0 lg:pl-64 min-h-screen relative" :class="sideBarOpen ? 'overlay md:w-2/3' : ''" id="main-content">
                <Navbar class="bg-gray-50" />
                <div class="p-6 bg-gray-50 pb-10" style="min-height: calc(100vh - 160px);">  
                    <vue-page-transition name="fade">
                        <router-view />
                    </vue-page-transition>
                </div>
                <Footer :config="webConfig.config" />
            </div>
        </div>
    </div>
</template>
    
<script>
import { mapGetters, mapActions } from 'vuex'
import Sidebar from '@/components/admin/sidebar-admin'
import Navbar from '@/components/admin/navbar-admin'
import Footer from '@/components/admin/footer-admin'
import 'viewerjs/dist/viewer.css'

export default {
    name: 'index',
    components: {
        Sidebar,
        Footer,
        Navbar
    },
    data() {
        return {
            webConfig: {
                config: {}
            }
        }
    },
    computed: {
        ...mapGetters('admin', ['sideBarOpen'])
    },
    methods: {
        ...mapActions('webConfig', ['GetWebConfigList']),
        async getConfig(){
            let response = await this.GetWebConfigList()
            this.webConfig = response.data
        }
    },
    created() {
        this.getConfig()
    }
};
</script>
    
<style>
.web-background {
    background-color: white;
}
div {
    font-family: gil;
}
a {
    text-decoration: none !important;
}
html {
    scroll-behavior: smooth;
}
.image_hover:hover {
    -webkit-transform: scale(1.05);
    transform: scale(1.05);
}

.image_hover {
    -webkit-transition: all 0.7s ease;
    transition: all 0.7s ease;
}
.overlay {
    position: relative; 
}

/* 1024 -1 so it doesnt show when it hits 1024px */
@media only screen and (max-width: 1023px) {
    .overlay:after {
        content: " ";
        z-index: 29;
        display: block;
        height: 100%;
        top: 80px;
        left: 0;
        right: 0;
        background: rgba(0, 0, 0, 0.5);
        pointer-events: none;
        position: fixed;
    }
}
</style>
    